module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ed839a3be50a57c11f4bf418803a5ed0.png";